import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import PageProvider from '../context/AppContext';
import Section from './Section';
import Footer from './Footer';

export const PageContext = createContext(null);

export default function Layout(props) {
    const { pageProps, children } = props;

    return (
        <PageProvider pageProps={pageProps}>
            { children }
            <Section color="steelgray">
                <Footer />
            </Section>
        </PageProvider>
    );
}

Layout.defaultProps = {
    children: null,
    pageProps: {},
};

Layout.propTypes = {
    children: PropTypes.node,
    pageProps: PropTypes.any,
};
